import { ApiError, api } from "../api/client";
import type { GeocodeCandidate } from "@shared/api";

/**
 * Address-search helpers shared across the marketing and viewer routes.
 *
 * The previous `navigateToMarketing` helper that hard-reloaded to `/` is
 * gone — ViewerTopNav uses React Router's `useNavigate` directly now so the
 * persistent header survives the route swap.
 */
export async function geocodeAddress(
  query: string,
  limit = 5
): Promise<{ candidates: GeocodeCandidate[]; errorMessage?: string }> {
  const q = query.trim();
  if (!q) {
    return { candidates: [] };
  }
  try {
    const res = await api.geocode(q, limit);
    return { candidates: res.candidates };
  } catch (err) {
    const message =
      err instanceof ApiError
        ? `${err.code}: ${err.message}`
        : (err as Error).message;
    return { candidates: [], errorMessage: message };
  }
}

export function defaultAddressStatus(
  candidatesLength: number,
  trimmedQuery: string
): { text: string; isError: boolean } {
  if (!trimmedQuery) {
    return { text: "", isError: false };
  }
  if (candidatesLength === 0) {
    return {
      text: "No matches yet — Phase 1 stub only resolves the default address.",
      isError: false
    };
  }
  return { text: "", isError: false };
}
